export enum IconTypesEnum {
  MAT = 'mat',
  MDI = 'mdi',
  SVG = 'svg',
}
